import { jsx as _jsx } from 'react/jsx-runtime.js';
import { SocialAppleButton } from '@stepstone-genesis/components';
import { useTranslation } from '@stepstone-platform/i18n';
import { useAppleLogin } from '../useAppleLogin.js';
import { useAppDispatch, useAppSelector } from '../../../hooks.js';
import { authWithAppleThunk, isLoadingSelector } from '../loginWithAppleSlice.js';
import { useTrack } from '../../../../tracking/common/hooks/useTrack.js';
export const AppleButtonComponent = ({ buttonText, }) => {
    const { t } = useTranslation();
    const { initialized } = useAppleLogin();
    const dispatch = useAppDispatch();
    const isLoading = useAppSelector(isLoadingSelector);
    const { trackBtnClick, trackFailedAttempt } = useTrack('twoStep');
    const onSignIn = async () => {
        trackBtnClick({ uniqueName: 'apple' });
        try {
            await dispatch(authWithAppleThunk()).unwrap();
        }
        catch (errorCode) {
            trackFailedAttempt({
                formFailedAttemptsErrors: 'appleAuthenticationFailed',
            });
        }
    };
    return initialized ? (_jsx(SocialAppleButton, { "data-testid": "apple-login-btn", "data-dd-action-name": "rla_forms_twoStep_appleClick", as: "button", a11yLabel: t('loginregistration.login.appleButton.a11yLabel'), type: "button", isLoading: isLoading, isFullWidth: true, size: ['medium'], onClick: onSignIn, children: buttonText ?? t('loginregistration.login.appleButton') })) : null;
};
//# sourceMappingURL=AppleButtonComponent.js.map